export default __webpack_public_path__ + "static/media/tc-fig2.6f4e8bc2.svg";